import {DRAWER_OPEN, DRAWER_CLOSE} from 'app/redux/constants/actionTypes';

export default function drawerToggle(state = false, action) {
  switch (action.type) {
    case DRAWER_OPEN:
      return 'open';
    case DRAWER_CLOSE:
      return 'close';
    default:
      return 'close';
  }
}